/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MovimentoMangimeCreateDTO
 */
export interface MovimentoMangimeCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof MovimentoMangimeCreateDTO
     */
    quantita?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoMangimeCreateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMangimeCreateDTO
     */
    valoreFixed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMangimeCreateDTO
     */
    idCapannone?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMangimeCreateDTO
     */
    idTipoMangime?: number;
}

/**
 * Check if a given object implements the MovimentoMangimeCreateDTO interface.
 */
export function instanceOfMovimentoMangimeCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MovimentoMangimeCreateDTOFromJSON(json: any): MovimentoMangimeCreateDTO {
    return MovimentoMangimeCreateDTOFromJSONTyped(json, false);
}

export function MovimentoMangimeCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovimentoMangimeCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantita': !exists(json, 'quantita') ? undefined : json['quantita'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'valoreFixed': !exists(json, 'valoreFixed') ? undefined : json['valoreFixed'],
        'idCapannone': !exists(json, 'idCapannone') ? undefined : json['idCapannone'],
        'idTipoMangime': !exists(json, 'idTipoMangime') ? undefined : json['idTipoMangime'],
    };
}

export function MovimentoMangimeCreateDTOToJSON(value?: MovimentoMangimeCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantita': value.quantita,
        'note': value.note,
        'valoreFixed': value.valoreFixed,
        'idCapannone': value.idCapannone,
        'idTipoMangime': value.idTipoMangime,
    };
}

